module.exports = __webpack_public_path__ + "img/qrcode.0f66e939.jpg";